import { Paper } from '@mantine/core';
import { Route, Switch } from 'wouter';
import InvoicingCompaniesList from './InvoicingCompaniesList';
import InvoicingCompanyDetail from './InvoicingCompanyDetail';
import InvoicingCompanyCreate from './InvoicingCompanyCreate';

export default function InvoicingCompaniesPage() {
  return (
    <Paper p="md" h="100%">
      <Switch>
        <Route path="/new" component={InvoicingCompanyCreate} />
        <Route path="/:id" component={InvoicingCompanyDetail} />
        <Route path="/" component={InvoicingCompaniesList} />
      </Switch>
    </Paper>
  );
}
